import { render, staticRenderFns } from "./format-select.vue?vue&type=template&id=9fd9cf2a&scoped=true&"
import script from "./format-select.vue?vue&type=script&lang=js&"
export * from "./format-select.vue?vue&type=script&lang=js&"
import style0 from "./format-select.vue?vue&type=style&index=0&id=9fd9cf2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fd9cf2a",
  null
  
)

export default component.exports